import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-note40',
  templateUrl: './note40.component.html',
  styleUrls: ['./note40.component.scss'],
})
export class Note40Component implements OnInit {
  // Component properties
    showInput1 = false;
    showInput2 = false;
    showInput3 = false;
    showInput4 = false;
    showInput5 = false;
    showInput6 = false;
  charityFundsForm : FormGroup;
  note40Form: FormGroup;
  calculativeData: any;

  @Input() triggerEditData: Observable<any>;

  private triggerSubscription!: Subscription;

  @Input() reloadTrigger: boolean = false;

  constructor(public commonService: CommonService) {}

  


  ngOnInit(): void {
    this.setForm();
    this.subscribeToTrigger();
  }

   ngOnChanges(changes: SimpleChanges): void {
    // if (changes['triggerEditData']) {
    //   this.subscribeToTrigger();
    // }
     if (this.reloadTrigger) {
      console.log('Reloading child...');
      this.subscribeToTrigger(); // Your reload logic here

      this.showInput1 = false;
      this.showInput2 = false;
      this.showInput3 = false;
      this.showInput4 = false;
      this.showInput5 = false;
      this.showInput6 = false;
    }
  }

  editNotes40(res): void {
    this.note40Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
      textbox2: res.textbox2 ? res.textbox2 : '',
      textbox3: res.textbox3 ? res.textbox3 : '',
      textbox4: res.textbox4 ? res.textbox4 : '',
    });
  }

  setForm(): void {
    this.note40Form = new FormGroup({
  textbox1: new FormControl(''),
  textbox2: new FormControl(''),
  textbox3: new FormControl(''),
  textbox4: new FormControl(''),

  thisYearAmount1: new FormControl(0, [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ]),
  thisYearAmount2: new FormControl(0, [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ]),
  thisYearAmount3: new FormControl(0, [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ]),
  lastYearAmount1: new FormControl(0, [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ]),
  lastYearAmount2: new FormControl(0, [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ]),
  lastYearAmount3: new FormControl(0, [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ])
});

  }


  filterItems(calculativeData: any, fundType: string): any {
    return calculativeData.filter((x) =>
      x.type.toLowerCase().startsWith(fundType)
    );
  }

  public thisYearAmount1: any;
  public thisYearAmount2: any;
  public thisYearAmount3: any;
  public lastYearAmount1: any;
  public lastYearAmount2: any;
  public lastYearAmount3: any;

  public isInvalidInput1: boolean = false;
  public isInvalidInput2: boolean = false;
  public isInvalidInput3: boolean = false;
  public isInvalidInput4: boolean = false;
  public isInvalidInput5: boolean = false;
  public isInvalidInput6: boolean = false;

  onContentChange(event: Event, type: number): void {
    const content = (event.target as HTMLElement).innerText.trim();
    const isValidPositiveNumber = content === '' || /^\d+(\.\d+)?$/.test(content);
    switch(type) {
      case 1:
        this.isInvalidInput1 = !isValidPositiveNumber;
        this.thisYearAmount1 = content === "" ? 0 : content;
        break;
      case 2:
        this.isInvalidInput2 = !isValidPositiveNumber;
        this.thisYearAmount2 = content === "" ? 0 : content;
        break;
      case 3:
        this.isInvalidInput3 = !isValidPositiveNumber;
        this.thisYearAmount3 = content === "" ? 0 : content;
        break;
      case 4:
        this.isInvalidInput4 = !isValidPositiveNumber;
        this.lastYearAmount1 = content === "" ? 0 : content;
        break;
      case 5:
        this.isInvalidInput5 = !isValidPositiveNumber;
        this.lastYearAmount2 = content === "" ? 0 : content;
        break;
      case 6:
        this.isInvalidInput6 = !isValidPositiveNumber;
        this.lastYearAmount3 = content === "" ? 0 : content;
        break;
    }
  }

  private subscribeToTrigger(): void {
    if (this.triggerSubscription) {
      this.triggerSubscription.unsubscribe(); 
    }

    

    this.triggerSubscription = this.triggerEditData.subscribe((data) => {
      if (data.noteId === Notes.Note40) {
        this.calculativeData = data.response.calculativeData;

        console.log("===",this.calculativeData?.fundTransferDataCurrentPeriod);
        console.log("-----",this.calculativeData?.fundTransferDataPreviousPeriod);

        

        this.note40Form.patchValue({
          thisYearAmount1: this.calculativeData?.fundTransferDataCurrentPeriod?.amount1,
          thisYearAmount2: this.calculativeData?.fundTransferDataCurrentPeriod?.amount2,
          thisYearAmount3: this.calculativeData?.fundTransferDataCurrentPeriod?.amount3,
          lastYearAmount1: this.calculativeData?.fundTransferDataPreviousPeriod?.amount1 ?? 0,
          lastYearAmount2: this.calculativeData?.fundTransferDataPreviousPeriod?.amount2 ?? 0,
          lastYearAmount3: this.calculativeData?.fundTransferDataPreviousPeriod?.amount3 ?? 0
        });


        if (data.response.userInputData?.data) {
          this.editNotes40(data.response.userInputData.data);
        }
      }

    });

    
  }

  loadData(data: any): void {
    this.calculativeData = data?.response?.calculativeData;
  }

  ngOnDestroy(): void {
    if (this.triggerSubscription) {
      this.triggerSubscription.unsubscribe();
    }
  }

  persistRow3: boolean = false;
  activeRow: number | null = null;


  editRow(rowIndex: number): void {
  // If row 3 is already triggered, don't switch back to row 2
  if (this.persistRow3 && rowIndex === 2) {
    return; // Ignore future clicks on row 2
  }

  if (rowIndex === 2) {
    this.persistRow3 = true;     // Lock Row 3
    this.activeRow = 3;
  } else {
    this.activeRow = rowIndex;
  }
}



  closeEdit(): void {
  // Don't close row 3 if it's locked
  if (this.persistRow3 && this.activeRow === 3) {
    return;
  }
  this.activeRow = null;
}

resetIfEmpty(controlName: string): void {
  const control = this.note40Form.get(controlName);
  if (control && (control.value === null || control.value === '' || control.value === undefined))
 {
    control.setValue(0);
  }
}

onInputBlur(): void {
  this.activeRow = null; // closes editing and shows value again
}




// Just toggle specific row — no reset of other rows
showInput(row: number): void {
  switch (row) {
    case 1: this.showInput1 = true; break;
    case 2: this.showInput2 = true; break;
    case 3: this.showInput3 = true; break;
    case 4: this.showInput4 = true; break;
    case 5: this.showInput5 = true; break;
    case 6: this.showInput6 = true; break;
  }
}



}
